// Matches the legacy `Inp` atom in app/frontend/index.html.

import { clsx } from "clsx";
import type { CSSProperties } from "react";

interface InputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: "text" | "password" | "email" | "number";
  textarea?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function Input({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  textarea,
  className,
  style,
}: InputProps) {
  // text-base (16px) on mobile prevents iOS Safari from auto-zooming the
  // viewport when the field gains focus — anything below 16px triggers
  // the zoom and the layout never recovers cleanly. md+ keeps a dense
  // 14px desktop look. Touch target hits 44px on mobile, drops to ~40px
  // on md+ where mouse precision makes the extra height feel chunky.
  const fieldClass =
    "w-full px-3 py-3 md:py-2 min-h-[44px] md:min-h-[40px] " +
    "bg-bg border border-stroke rounded text-content " +
    "font-mono text-base md:text-[14px] outline-none box-border";

  return (
    <div className={clsx("mb-3", className)} style={style}>
      {label && (
        <label className="block mb-1 font-mono text-[11px] text-muted uppercase tracking-[0.05em]">
          {label}
        </label>
      )}
      {textarea ? (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={4}
          className={clsx(fieldClass, "resize-y")}
        />
      ) : (
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={fieldClass}
        />
      )}
    </div>
  );
}
